<template>
  <div class="main">
    <div class="body">
      <h1>ポジティブおみくじ！</h1>
      <div v-show="result" id="result">
        <h2>{{"大".repeat(count)}}吉</h2>
        <p style="color: #E60012">
          <span>願事:</span>
          めっっちゃ叶う{{ "!".repeat(count)}}
        </p>
        <p style="color: #F39800">
          <span>待人:</span>
          絶対来る{{ "!".repeat(count)}}
        </p>
        <p style="color: #009944">
          <span>商い:</span>
          絶対繁盛{{ "!".repeat(count)}}
        </p>
        <p style="color: #0068B7">
          <span>学問:</span>
          必ず成功{{ "!".repeat(count)}}
        </p>
        <p style="color: #1D2088">
          <span>病気:</span>
          ずっと健康{{ "!".repeat(count)}}
        </p>
        <p style="color: #920783">
          <span>争い:</span>
          起きない{{ "!".repeat(count)}}
        </p>
        <p style="color: #E60012">
          <span>恋愛:</span>
          絶対叶う{{ "!".repeat(count)}}
        </p>
        <p style="color: #F39800">
          <span>総合:</span>
          最高{{ "!".repeat(count)}}
        </p>
      </div>
      <button @click="clickOmikuji">引く！</button>
      <div>
        <a
          href="https://twitter.com/share?ref_src=twsrc%5Etfw"
          class="twitter-share-button"
          data-show-count="false"
        >Tweet</a>
        <a
          href="http://b.hatena.ne.jp/entry/s/wonderful-kepler-5018a5.netlify.com/%23/"
          class="hatena-bookmark-button"
          data-hatena-bookmark-layout="touch"
          data-hatena-bookmark-width="40"
          data-hatena-bookmark-height="40"
          title="このエントリーをはてなブックマークに追加"
        >
          <img
            src="https://b.st-hatena.com/images/entry-button/button-only@2x.png"
            alt="このエントリーをはてなブックマークに追加"
            width="20"
            height="20"
            style="border: none;"
          >
        </a>
      </div>
    </div>
    <footer>
      <a href="https://twitter.com/razokulover" target="_blank">© 2019 razokulover</a>
    </footer>
  </div>
</template>

<script>
if (!String.prototype.repeat) {
  String.prototype.repeat = function(count) {
    return Array(count * 1 + 1).join(this);
  };
}

export default {
  name: "Home",
  data() {
    return {
      loading: false,
      result: false,
      count: 0
    };
  },
  methods: {
    clickOmikuji() {
      if (this.loading) return;
      this.loading = true;
      this.result = false;
      const randomColor = () => {
        const o = Math.round,
          r = Math.random,
          s = 255;
        return (
          "rgba(" +
          o(r() * s) +
          "," +
          o(r() * s) +
          "," +
          o(r() * s) +
          "," +
          r().toFixed(1) +
          ")"
        );
      };

      const intevalTimer = setInterval(() => {
        document.querySelector("body").style[
          "background-color"
        ] = randomColor();
      }, 100);

      setTimeout(() => {
        clearInterval(intevalTimer);
        this.result = true;
        setTimeout(() => {
          document.querySelector("body").style["background-color"] = "#ffffff";
          location.href = "#";
          location.href = "#result";
          this.loading = false;
          this.count++;
        });
      }, 1500);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: bold;
  font-size: 18vw;
}
h2 {
  color: crimson;
}
p {
  font-size: 9vw;
}
p span {
  font-weight: bold;
}
button {
  width: 30vw;
  height: 10vw;
  border-radius: 10px;
  background-color: #eeeeee;
  font-size: 5vw;
  color: #2c3e50;
  outline: none;
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 20px;
}
a {
  color: #42b983;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
footer {
  position: fixed;
  bottom: 0;
  text-align: center;
  display: block;
  width: 100%;
}
.body {
  padding: 0 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue